module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('BlogList'), _vm._v(" "), _vm._c('div', {
    staticClass: "xs-pb-30 container"
  }, [_vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c527efd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/BlogPage.vue
// module id = 713
// module chunks = 1